export const ELLII_BOT_NAME = 'Ellii Bot'

export const GOOGLE_SSO_URL = '/omniauth/google_oauth2'

export const { RECAPTCHA_V3_SITE_KEY } = process.env
